<template>
	<div id="migration-done-modal" class="Modal">
		<div class="Modal__background"></div>
		<div class="Modal__container whole" :class="{ show: isShow }">
			<div class="Modal__content">
				<div class="imgbox">
					<img src="@/assets/images/migration-done.png" />
				</div>
				<h2 v-html="tt('랩매니저 PRO<br>전환 완료')"></h2>
				<!-- <p>기존 랩매니저 사용 데이터의 이전이 완료되었습니다.<br/>랩매니저 PRO의 새로운 기능을 지금 경험해보세요.</p> -->
				<p>
					고객요청에 의하여, 기존 계정의 연구실이<br />아래와 같이
					랩매니저 PRO로 전환되었습니다.<br />랩매니저 PRO의 새로운
					기능을 지금 경험하세요.
				</p>
				<div v-for="institute in data.institute">
					<ul class="prev-account">
						<li>기관명: {{ institute.name }}</li>
						<li>연구실: {{ institute.groupNames }}</li>
						<li>요청인: {{ institute.userName }}</li>
						<li>
							요청 일시:
							{{ dateTimeFormat(institute.startDatetime) }}
						</li>
					</ul>
					<ul class="license-noti">
						<li>
							라이선스: {{ institute.license.name }}(활성화 :
							{{ dateFormat(institute.startDatetime) }}까지)
						</li>
					</ul>
				</div>

				<div class="btn-wrap">
					<button class="Btn__complete" @click="hide()">
						랩매니저 PRO 시작하기
					</button>
					<button class="guide" @click="openLmGuide">
						랩매니저 가이드보기
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import migrationAPI from '@/services/api/eol/migration'
import { openExternal } from '@/utils/modules/WebBridge'

export default {
	name: 'MigrationDone',
	props: ['data'],
	data() {
		return {
			isShow: false, // Close 할때 이 값을 false로 바꿔주세요
		}
	},
	created() {},
	mounted() {
		setTimeout(() => {
			this.isShow = true
		}, 10)
	},
	methods: {
		openLmGuide() {
			openExternal(
				'https://smartjack.notion.site/User-Guide-Mobile-0931d1f5f89b40269f6213a0f33808ff'
			)
		},
		dateFormat(date) {
			date = new Date(date)

			const y = date.getFullYear()
			const M = date.getMonth() + 1
			const d = date.getDate()

			const h = date.getHours()
			const m = date.getMinutes()

			return `${y}-${M > 10 ? M : `0${M}`}-${d > 10 ? d : `0${d}`}`
		},
		dateTimeFormat(date) {
			date = new Date(date)
			const h = date.getHours()
			const m = date.getMinutes()

			return `${this.dateFormat(date)} ${h > 10 ? h : `0${h}`}:${
				m > 10 ? m : `0${m}`
			}`
		},
		hide() {
			migrationAPI.completeFirstVisit()
			this.$emit('hide')
		},
	},
}
</script>

<style lang="scss">
#migration-done-modal {
	display: block;

	.Modal__container {
		bottom: calc(var(--vh, 1vh) * -100);
		-webkit-transition: bottom 0.5s linear;
		transition: bottom 0.5s linear;

		&.show {
			bottom: 0;
		}
	}

	.Modal__content {
		padding: 0 27.5px;
	}
	.imgbox {
		width: 112px;
		height: 112px;
		margin: 50px auto 0;
		img {
			width: 100%;
		}
	}
	h2 {
		font-size: 2rem;
		font-weight: 700;
		margin: 20px 0 12px;
		text-align: center;
		word-break: keep-all;
	}
	p {
		font-size: 0.875rem;
		font-weight: 400;
		margin-bottom: 20px;
		text-align: center;
	}
	ul {
		width: 100%;
		border-radius: 10px;
		border: 1px solid #eee;
		padding: 12px;
		margin-bottom: 10px;
		&.license-noti {
			margin-bottom: 20px;
		}
		li {
			position: relative;
			font-size: 0.875rem;
			color: #000;
			font-weight: 400;
			padding-left: 20px;
			line-height: 1.5;
			&:before {
				position: absolute;
				width: 3px;
				height: 3px;
				content: '';
				background-color: #000;
				border-radius: 8px;
				top: 10px;
				left: 6px;
			}
		}
	}
	.btn-wrap {
		width: 100%;
		margin-bottom: 20px;
		button {
			display: block;
			width: 100%;
			&.Btn__complete {
				height: 48px;
				font-weight: 700;
				font-size: 1.125rem;
			}
			&.guide {
				margin-top: 20px;
				font-size: 0.875rem;
				color: #666;
				font-weight: 400;
			}
		}
	}
}
</style>
